import React from 'react';

import { Route, Switch, useRouteMatch } from 'react-router-dom';

import ProfilePage from './ProfilePage';

const ProfileRoutes: React.FC = () => {
    const { path } = useRouteMatch();

    console.log('ProfileRoutes path', path);
    return (
        <>
            <Switch>
                <Route exact path={`${path}`} component={ProfilePage} />
                <Route exact path={`${path}/:profileId`} component={ProfilePage} />
            </Switch>
        </>
    );
};

export default ProfileRoutes;
